import React, { useEffect, useState } from 'react';
import { useAccount } from 'wagmi';
import { useAprAuth } from './hooks/useAprAuth';
import { Dashboard } from './components/Dashboard';
import { Leaderboard } from './components/Leaderboard';
import { Loader2 } from 'lucide-react';

const SHOW_APR_BOOST = import.meta.env.VITE_SHOW_APR_BOOST === 'true';

export const AprPointsPage: React.FC = () => {
  const { isConnected, address } = useAccount();
  const { isAuthenticated, isAuthenticating, isChecking, login } = useAprAuth();
  const [attemptedAddress, setAttemptedAddress] = useState<string | null>(null);

  // Auto-trigger login when page loads if connected but not authenticated
  useEffect(() => {
    if (!isConnected || !address || !SHOW_APR_BOOST) {
      setAttemptedAddress(null);
      return;
    }

    if (
      !isChecking &&
      !isAuthenticated &&
      !isAuthenticating &&
      attemptedAddress !== address
    ) {
      setAttemptedAddress(address);
      login();
    }
  }, [
    isConnected,
    address,
    isAuthenticated,
    isAuthenticating,
    isChecking,
    attemptedAddress,
    login,
  ]);

  if (isChecking && isConnected) {
    return (
      <div className="w-full max-w-[1200px] mx-auto px-4 py-12 flex flex-col items-center justify-center text-center min-h-[400px]">
        <Loader2 className="w-8 h-8 text-primarybrand animate-spin" />
      </div>
    );
  }

  return (
    <div className="w-full max-w-[1200px] mx-auto px-4 pt-4 pb-8 space-y-8">
      <Dashboard isAuthenticated={isAuthenticated} onVerifyClick={login} />
      <Leaderboard />
    </div>
  );
};
